import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getKeysAction } from "../actions/get-keys.action";
import { KeysState } from "domain/keys/entities/interfaces/keys-state.interface";
import { sortDataByAlphabet } from "app/data/helpers";

const getKeysCases = (builder: ActionReducerMapBuilder<KeysState>) => {
  builder.addCase(getKeysAction.pending, (state) => {
    state.isLoadingKeys = true;
  });
  builder.addCase(getKeysAction.fulfilled, (state, action) => {
    state.keys = sortDataByAlphabet(action?.payload, "label");
    state.isLoadingKeys = false;
  });
  builder.addCase(getKeysAction.rejected, (state) => {
    state.isLoadingKeys = false;
  });
};

export default getKeysCases;
